module.exports = __webpack_public_path__ + "img/company-1.6aeaad3c.jpg";